import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import { GET_TERRITORY_SUCCESS, GET_TERRITORY_FAILURE } from '../actions';

import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getTerritory(action) {
    const params = convertObjectToQueryParams({
        ...action.payload,
    });

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/aardt/territories?${params}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        if (result.territories?.length > 0) {
            const territoryLists = result.territories.map((territory) => {
                return {
                    ...territory,
                    id:
                        territory.terrirotryCode === 'GSE'
                            ? territory.terrirotryCode + '_T'
                            : territory.terrirotryCode,
                    name: territory.terrirotryName,
                };
            });

            result.territories = [...territoryLists];
        }

        yield put({ type: GET_TERRITORY_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_TERRITORY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
